import { useIsFreeOrStarterPortal } from 'onboarding-scopes';
import useHasTwoMonthOrLessStarterSubscription from 'FormsUI/components/hooks/zeroState/useHasTwoMonthOrLessStarterSubscription';
import usePortalIsTwoOrLessMonthsOld from 'FormsUI/components/hooks/zeroState/usePortalIsTwoOrLessMonthsOld';
import isAcceptanceTest from 'forms-utils-lib/localStorage/isAcceptanceTest';
const useShowFreeStarterEmptyState = isPortalZeroState => {
  const isNotProPlusPortal = useIsFreeOrStarterPortal();
  const isNewStarterSubscription = useHasTwoMonthOrLessStarterSubscription();
  const isNewFreePortal = usePortalIsTwoOrLessMonthsOld();
  const acceptanceTest = isAcceptanceTest();
  const isAudience = isPortalZeroState && isNotProPlusPortal && (isNewStarterSubscription || isNewFreePortal) && !acceptanceTest;
  return isAudience;
};
export default useShowFreeStarterEmptyState;